import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Option, OptionFilters, OptionSort } from '../../lib/types/models/options/option'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getOptions(
  input: PaginationRequest<OptionFilters, string, Version, OptionSort> = {}
) {
  if (!input.sort) input.sort = { title: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.options.getAll.url, null), input))
    .get<PaginationResponse<Option>>()
}
